<script>
export default 
{
    name: 'checkmark',

    props: {
        value: null,
        readonly: Boolean,
    },

    watch:
    {
        value()
        {
            this.internalValue = this.value
        },

        internalValue()
        {
            if (!this.readonly)
                this.$emit('input', this.internalValue)
        }
    },

    data()
    {
        return {
            internalValue: this.value
        }
    }
    
}
</script>

<template>
<label class="checkmark-container">
    <input type="checkbox" v-model="internalValue" :readonly="readonly" :disabled="readonly">
    <span class="checkmark"></span>
    <span class="after">
        <slot></slot>
    </span>
</label>
</template>

<style lang="scss">
html {
    --checkbox-color: #FFCCD9;
}
$checkbox-width: 18px;
$checkbox-height: 18px;

.selected {
    label.checkmark-container {
        opacity: 1;
    }
}

label.checkmark-container {
    opacity: .5;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    user-select: none;
    width: $checkbox-width;
    height: $checkbox-height;
    margin: 0 .75em 0 0;
    border: 1px solid var(--checkbox-color);
    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .checkmark {
        position: absolute;
        left: 0;
        height: ($checkbox-width - 2px);
        width: ($checkbox-height - 2px);
        background-color: white;
        transition: background-color .4s;
    }

    .checkmark:after {
        content: '';
        position: absolute;
        display: block;
        opacity: 0;
        left: 6px;
        top: 3px;
        width: 5px;
        height: 10px;
        border: solid var(--checkbox-color);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        transition: opacity .4s;
    }

    input:checked ~ .checkmark {
        background-color: white;
    }

    input:checked ~ .checkmark:after {
        opacity: 1;
    }

    .after {
        margin-left: ($checkbox-width + 5px);
        white-space: nowrap;
        color: var(--checkbox-color);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/CheckMark.vue